import axios from '../axios/interceptor';

export const fetchCategories = async (businessId) => {
    const response = await axios.get(`business/${businessId}/categories`);
    return response.data; 
}   

export const createCategory = async (businessId, categoryData) => {
    const response = await axios.post(`business/${businessId}/categories`, categoryData);
    return response.data; 
}

export const updateCategory = async (businessId, categoryId, categoryData) => {
    const response = await axios.put(`business/${businessId}/categories/${categoryId}`, categoryData);
    return response.data; 
}

export const deleteCategory = async (businessId, categoryId) => {
    const response = await axios.delete(`business/${businessId}/categories/${categoryId}`);
    return response.data; 
}